import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';

const PROMO_CODES_COLLECTION = 'promo_codes';

export interface PromoCodeConfig {
  code: string;
  /** Quantidade de cervejas extras por mês para o assinante. */
  extraBeers: number;
  /** Por quantos meses o assinante recebe as cervejas extras. */
  months: number;
  active: boolean;
  description?: string;
}

/**
 * Busca um código promocional pelo valor digitado.
 * Códigos são comparados em maiúsculas e sem espaços nas pontas.
 * Retorna null se não existir ou estiver inativo.
 */
export async function getPromoCodeByCode(
  code: string,
): Promise<PromoCodeConfig | null> {
  const normalized = code.trim().toUpperCase();
  if (!normalized || normalized.length < 2) return null;

  const q = query(
    collection(firestore, PROMO_CODES_COLLECTION),
    where('code', '==', normalized),
    where('active', '==', true),
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;

  const data = snap.docs[0].data();
  return {
    code: data.code ?? normalized,
    extraBeers: Number(data.extraBeers) || 1,
    months: Number(data.months) || 1,
    active: Boolean(data.active),
    description: data.description,
  };
}
